import { render, staticRenderFns } from "./detailIframe.vue?vue&type=template&id=fcba805a&scoped=true&"
import script from "./detailIframe.vue?vue&type=script&lang=js&"
export * from "./detailIframe.vue?vue&type=script&lang=js&"
import style0 from "./detailIframe.vue?vue&type=style&index=0&id=fcba805a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcba805a",
  null
  
)

export default component.exports